import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { StatusLabelComponent } from '../../../shared/components/status-label/status-label.component';
import { StatusModalService } from '../../../core/services/status-modal.service';
import { SnackbarComponent } from '../../../shared/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Status } from '../../../shared/models/status-label.model';

@Component({
  selector: 'app-test-page',
  imports: [
    StatusLabelComponent,
    MatButton,
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
  ],
  templateUrl: './test-page.component.html',
  styleUrl: './test-page.component.scss',
})
export class TestPageComponent {
  private readonly statusModalService = inject(StatusModalService);

  readonly snackbar = inject(MatSnackBar);

  readonly statuses = Status;

  public showModalDialog(): void {
    this.statusModalService.open({
      state: 'error',
      title: 'Error Occurred',
      message: `Adding website test2 started`,
      highlights: ['test2'],
    });
  }

  public showSnackbar(): void {
    this.snackbar.openFromComponent(SnackbarComponent, {
      data: {
        text: `Adding website test232 started`,
        highlights: ['test232'],
      },
    });
  }
}
